const e = 160, a = 180, n = "35px", o = "320px", t = "640px", c = "960px", s = "1280px", r = "8px", p = "16px", i = "4px", b = "0.5rem", m = "#0C2A4DCC", S = "0.25rem", x = "0.5rem", k = "640px", B = "960px", l = "1280px", d = "0.5rem";
export {
  e as a,
  a as b,
  x as c,
  k as d,
  S as e,
  m as f,
  d as g,
  b as h,
  B as i,
  l as j,
  o as k,
  t as l,
  c as m,
  s as n,
  i as o,
  r as p,
  p as q,
  n as r
};
